import { breakpointPxs as breakpoints } from './breakpoints';
import { getButtonStyle } from './buttons';
import colors from './colors';
import colorModes from './modes/colorModes';
import { fontSizes, bodySizes, headingSizes } from './fontSizes';
import { fonts, fontWeights, fontStyles, lineHeights } from './fontStyles';
import { getBaseIconSize, getIconSize, } from './iconSizes';
import { media } from './media';
import mediaSizes from './mediaSizes';
import screenReader from './screenReader';
import sizes from './sizes';
import { getBaseSpace, getSpace } from './space';
import textStyles from './textVariants';
var containerWidths = ['932px', '1132px', '1192px'];
export var getMuiTheme = function (variant) { return ({
    baseIconSize: getBaseIconSize(variant),
    baseSpace: getBaseSpace(variant),
    bodySizes: bodySizes,
    breakpoints: breakpoints,
    buttons: getButtonStyle(variant),
    colorModes: colorModes,
    colors: colors,
    containerWidths: containerWidths,
    fonts: fonts,
    fontSizes: fontSizes,
    fontStyles: fontStyles,
    fontWeights: fontWeights,
    headingSizes: headingSizes,
    iconSize: getIconSize(variant),
    lineHeights: lineHeights,
    media: media,
    mediaSizes: mediaSizes,
    screenReader: screenReader,
    sizes: sizes,
    space: getSpace(variant),
    textStyles: textStyles,
}); };
//# sourceMappingURL=index.js.map